if(!customElements.get('form-variants')){
  customElements.define('form-variants', class Counter extends HTMLElement {
    constructor(){
      super();

      this.items = []
      this.variants = [...this.querySelectorAll('[quantity]')]
      this.addToCart = this.querySelector('[add-variants]')
      this.loader = this.querySelector('.loading-overlay__spinner')

      this.addToCart.addEventListener('click', this.onAddToCart.bind(this))
      
      this.cartPopupcontainer = document.querySelector('[data-cart-popup-wrapper]')
      this.cartPopupwrapperItems = document.querySelector('[cart-items-loop]')
      this.cartPopupQuantity = document.querySelector('[data-cart-popup-cart-quantity]')
      this.cartPopupClose = document.querySelector('[data-cart-popup-close]')

      this.cartPopupClose.addEventListener('click', () => {
        document.querySelector('.cart-popup-wrapper').classList.add('cart-popup-wrapper--hidden')
      })
    }

    onAddToCart(evt){
      evt.preventDefault()

      this.variants.map(variant => {
        if(variant.value > 0){
          this.items.push({
            id: variant.getAttribute('variant-id'),
            quantity: Number(variant.value) || 1
          })
        }
      })

      if(this.items.length === 0) return false

      this.cartPopupcontainer.classList.add('cart-popup-wrapper--hidden')
      this.loader.classList.remove('hidden')

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'items': this.items
        })
      })
      .then(response => {
        if(response.status === 422) location.reload()
        if(response.status === 200){
          return response.json()
        }
      })
      .then(response => {
        this.onShowConfirmMessage(response)
        this.loader.classList.add('hidden')
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    }

    getTransformCartItem(item) {
      const { options_with_values: options, featured_image, title, quantity } = item
      
      const htmlCartItem = `
        <div class="cart-popup-item">
          <div class="cart-popup-item__image-wrapper" data-cart-popup-image-wrapper="">
            <div class="cart-popup-item__image cart-popup-item__image--placeholder hide" data-cart-popup-image-placeholder="" style="max-width: 95px;">
              <div data-placeholder-size="" style="padding-top: 100%;"></div>
              <div class="placeholder-background placeholder-background--animation"></div>
            </div>
          <img src="${featured_image?.url}" alt="${ title }" class="cart-popup-item__image" data-cart-popup-image=""></div>
          <div class="cart-popup-item__description">
            <div>
              <h3 class="cart-popup-item__title" data-cart-popup-title="">${ title }</h3>
              <ul class="product-details" aria-label="Detalles del producto" data-cart-popup-product-details="" hidden="hidden">${
                options.map(option => {
                  return `<li><span>${option.name}:</span> ${option.value}</li>`
                })
              }</ul>
            </div>
            <div class="cart-popup-item__quantity">
              <span class="visually-hidden" data-cart-popup-quantity-label="">Cantidad: ${ quantity }</span>
              <span aria-hidden="true">Cantidad:</span>
              <span aria-hidden="true" data-cart-popup-quantity="">${ quantity }</span>
            </div>
          </div>
        </div>
      `
      return htmlCartItem
    }
    onShowConfirmMessage(response) {
      this.cartPopupwrapperItems.innerHTML = ''
      let qty = 0

      response?.items?.map(item => {
        qty = qty + item.quantity
        this.cartPopupwrapperItems.innerHTML += this.getTransformCartItem(item)
      })

      this.cartPopupQuantity.innerHTML = qty
      this.cartPopupcontainer.classList.remove('cart-popup-wrapper--hidden')
    }
  })
}
